import type { SharePlatform } from "../types/share-buttons";

const $ = jQuery;

export function shareButtons() {

	const platforms: SharePlatform[] = [

		{
			name: 'email',
			title: 'Email',
			html: SAGE.icons[ 'email' ],
			buildUrl( data ) {
				let { url, text, title: subject } = data;
				const shareUrl = new URL( 'mailto://' );
				shareUrl.search = new URLSearchParams( {
					subject,
					body: text + '\n' + url,
				} ).toString();
				return shareUrl.toString();
			},
		},

		{
			name: 'facebook',
			title: 'Facebook',
			html: SAGE.icons[ 'logo-facebook' ],
			buildUrl( data ) {
				const shareUrl = new URL( 'https://www.facebook.com/sharer.php' );
				shareUrl.search = new URLSearchParams( {
					u: data.url,
				} ).toString();
				return shareUrl.toString();
			},
		},

		{
			name: 'twitter',
			title: 'Twitter',
			html: SAGE.icons[ 'logo-twitter-bird' ],
			buildUrl( data ) {
				const maxLength = 280;
				let { url, title: text } = data;
				if ( text.length > maxLength ) {
					text = text.substr( 0, maxLength ) + '…';
				}
				const shareUrl = new URL( 'https://twitter.com/intent/tweet' );
				shareUrl.search = new URLSearchParams( {
					url,
					text,
				} ).toString();
				return shareUrl.toString();
			},
		},

	];

	const title = document.title;
	const canonical = $( 'link[rel=canonical]' ).get( 0 ) as HTMLLinkElement | undefined;
	const description = $( 'meta[name=description]' ).get( 0 ) as HTMLMetaElement | undefined;

	const url = canonical ? canonical.href : location.href;
	const text = description ? description.content : '';

	const data: Required<ShareData> = { title, text, url };

	if ( navigator.share ) {

		$( 'body' ).on( 'click', '.share-button', e => {
			e.preventDefault();

			navigator.share( data )
				.catch( e => { } );

		} );

	} else {

		$( '.share-button' ).replaceWith( platforms.map( platform => {

			return $( '.share-button' ).clone()
				.attr( {
					href: platform.buildUrl( data ),
					title: platform.title,
					target: '_blank',
				} )
				.html( platform.html );

		} ) );

	}

}
